import React from "react";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    getDistrictList,
    getBlockList,
    getGpList,
    getTotalTaxNonTaxAmount,
} from "../../Service/TotalAvailableFund";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const TaxNonTaxAmount = () => {
    const getCurrentDate = () => new Date().toISOString().split("T")[0];

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState(getCurrentDate());

    const [totalFundDetails, setTotalFundDetails] = useState([]);
    const [district, setDistrict] = useState("");
    const [block, setBlock] = useState("");
    const [gp, setGp] = useState("");
    const [getDistrictDataList, setDistrictDataList] = useState([]);
    const [getBlockDataList, setBlockDataList] = useState([]);
    const [getGpDataList, setGpDataList] = useState([]);
    const [reportFor, setReportFor] = useState("");

    useEffect(() => {
        getDistrictList().then(function (result) {
            const response = result?.data;
            setDistrictDataList(response);
        });
    }, []);

    let DistrictListDropDown = <option>Loading...</option>;
    if (getDistrictDataList && getDistrictDataList.length > 0) {
        DistrictListDropDown = getDistrictDataList.map((distRow, index) => (
            <option key={index} value={distRow.DIST_LGD}>
                {distRow.DIST_NAME}
            </option>
        ));
    }

    const onDistrict = (e) => {
        const selectedDistrict = e.target.value;

        setDistrict(selectedDistrict);
        setBlock("");
        setGp("");
        setBlockDataList([]);
        setGpDataList([]);

        if (selectedDistrict) {
            getBlockList(selectedDistrict).then(function (result) {
                const response = result?.data;
                setBlockDataList(response);
            });
        }
    };

    let BlockListDropDown = <option>Loading...</option>;
    if (getBlockDataList && getBlockDataList.length > 0) {
        BlockListDropDown = getBlockDataList.map((blRow, index) => (
            <option key={index} value={blRow.BLOCK_LGD}>
                {blRow.BLOCK_NAME}
            </option>
        ));
    }

    const onBlock = (e) => {
        const selectedBlock = e.target.value;

        setBlock(selectedBlock);
        setGp("");
        setGpDataList([]);

        if (selectedBlock) {
            getGpList(selectedBlock).then(function (result) {
                const response = result?.data;
                setGpDataList(response);
            });
        }
    };

    let GpListDropDown = <option>Loading...</option>;
    if (getGpDataList && getGpDataList.length > 0) {
        GpListDropDown = getGpDataList.map((gpRow, index) => (
            <option key={index} value={gpRow.GP_LGD}>
                {gpRow.GP_NAME}
            </option>
        ));
    }

    const onGp = (e) => {
        setGp(e.target.value);
    };

    const onReportFor = (e) => {
        setReportFor(e.target.value);
        setTotalFundDetails([]);
    };

    const onSearch = () => {
        if (!reportFor) {
            toast.error("Please select Report For option");
            return;
        }
        if (!fromDate) {
            toast.error("Please select From Date");
            return;
        }

        if (!toDate) {
            toast.error("Please select To Date");
            return;
        }

        if (fromDate > toDate) {
            toast.error("From Date cannot be greater than To Date");
            return;
        }


        getTotalTaxNonTaxAmount(
            district ? district : 0,
            block ? block : 0,
            gp ? gp : 0,
            reportFor,
            fromDate,
            toDate
        ).then((response) => {
            if (response.status === 200) {
                response?.data?.statusMsg === "Success"
                    ? toast.success("Data Fetched Successfully")
                    : toast.error(response?.data?.statusMsg);

                setTotalFundDetails(response.data);
            } else {
                toast.error("Failed to fetch data");
            }
        });
    };

    const exportToExcel = () => {
        const worksheetData = totalFundDetails?.dtls?.map((item, index) => ({
            "SL No.": index + 1,
            "Zilla Parishad": item.priName,
            "Tax Amount": Number(item.taxAmount || 0),
            "Non-Tax Amount": Number(item.nonTaxAmount || 0),
            "Other Revenue": Number(item.otherAmount || 0),
            "Total Balance": Number(item.totalBalance || 0),
        }));

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);

        worksheet["!cols"] = [
            { wch: 8 },
            { wch: 35 },
            { wch: 18 },
            { wch: 22 },
            { wch: 20 },
            { wch: 20 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Total Tax Non Tax Amount Report"
        );

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Tax_Collection_Report.xlsx");
    };

    return (
        <div>
            <ToastContainer />

            <div
                className="bg-white rounded-lg p-2 flex flex-col flex-grow"
                style={{ marginTop: "-40px" }}
            >
                <legend className="text-lg font-semibold text-cyan-700">
                    Total Collection Status As on {new Date().toLocaleString()}
                </legend>

                <div className="flex flex-col space-y-2 py-1">
                    <div className="flex flex-col w-full mb-4 space-y-2">
                        <div className="flex items-center flex-wrap gap-y-2">
                            {/* District */}
                            <div className="w-1/4 px-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    District
                                </label>
                                <select
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    value={district}
                                    onChange={onDistrict}
                                >
                                    <option value="">Select District</option>
                                    {DistrictListDropDown}
                                </select>
                            </div>

                            {/* Block */}
                            <div className="w-1/4 px-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Block
                                </label>
                                <select
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    onChange={onBlock}
                                    value={block}
                                >
                                    <option value="">Select Block</option>
                                    {BlockListDropDown}
                                </select>
                            </div>

                            {/* Gram Panchayat */}
                            <div className="w-1/4 px-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Gram Panchayat
                                </label>
                                <select
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    onChange={onGp}
                                    value={gp}
                                >
                                    <option value="">Select Gram Panchayat</option>
                                    {GpListDropDown}
                                </select>
                            </div>

                            {/* Report For */}
                            <div className="w-1/4 px-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Report For <span className="text-red-500">*</span>
                                </label>
                                <select
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    onChange={onReportFor}
                                    value={reportFor}
                                >
                                    <option value="">Select Report For</option>
                                    <option value="1">ZP</option>
                                    <option value="2">PS</option>
                                    <option value="3">GP</option>
                                </select>
                            </div>

                            {/* From Date */}
                            <div className="w-1/4 px-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    From Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    max={toDate || getCurrentDate()}
                                />
                            </div>

                            {/* To Date */}
                            <div className="w-1/4 px-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    To Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={fromDate || ""}
                                    max={getCurrentDate()}
                                />
                            </div>

                            {/* Search Button */}
                            <div className="w-1/6 px-2">
                                <button
                                    type="button"
                                    className="btn-submit h-9 px-4 mt-5 shadow-sm text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    onClick={onSearch}
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>

                    {!totalFundDetails?.dtls || totalFundDetails?.dtls?.length === 0 ? (
                        <div
                            className="flex items-center justify-center bg-gray-200"
                            style={{ marginTop: "10px" }}
                        >
                            <div className="text-center">
                                <h1 className="text-xl font-semibold text-black-800">
                                    No Data Found
                                </h1>
                            </div>
                        </div>
                    ) : (
                        <div className="overflow-x-auto p-4">
                            <div className="flex justify-between items-center mb-2">
                                <button
                                    onClick={exportToExcel}
                                    className="bg-green-600 text-white px-2 py-2 rounded hover:bg-green-700 transition"
                                >
                                    Download Excel
                                </button>

                                <h2 className="text-lg font-semibold text-gray-800 text-center animate-blink flex-1">
                                    {reportFor === "1"
                                        ? "Zilla Parishad"
                                        : reportFor === "2"
                                            ? "Panchayat Samiti"
                                            : "Gram Panchayat"}{" "}
                                    wise Total Collection Status
                                </h2>
                            </div>

                            <div className="border rounded overflow-hidden">
                                <div className="max-h-[500px] overflow-y-auto">
                                    <table className="min-w-full divide-y divide-gray-200 border text-sm">
                                        <thead className="bg-cyan-600 text-white sticky top-0 z-10">
                                            <tr>
                                                <th className="px-4 py-2 text-left">SL No.</th>
                                                <th className="px-4 py-2 text-left">
                                                    Zilla Parishad
                                                </th>
                                                <th className="px-4 py-2 text-right">
                                                    Tax Revenue (₹)
                                                </th>
                                                <th className="px-4 py-2 text-right">
                                                    Non-Tax Revenue (₹)
                                                </th>
                                                <th className="px-4 py-2 text-right">
                                                    Other Revenue (₹)
                                                </th>
                                                <th className="px-4 py-2 text-right">
                                                    Total Revenue (₹)
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody className="divide-y divide-gray-100 bg-white">
                                            {totalFundDetails?.dtls?.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    className={
                                                        parseFloat(item.totalBalance) > 0
                                                            ? "bg-white"
                                                            : "bg-gray-50 text-gray-400"
                                                    }
                                                >
                                                    <td className="px-4 py-2">{index + 1}</td>
                                                    <td className="px-4 py-2">{item.priName}</td>

                                                    <td className="px-4 py-2 text-right">
                                                        {Number(item.taxAmount || 0).toLocaleString(
                                                            "en-IN",
                                                            { minimumFractionDigits: 2 }
                                                        )}
                                                    </td>

                                                    <td className="px-4 py-2 text-right">
                                                        {Number(
                                                            item.nonTaxAmount || 0
                                                        ).toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                    </td>

                                                    <td className="px-4 py-2 text-right">
                                                        {Number(
                                                            item.otherAmount || 0
                                                        ).toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                    </td>

                                                    <td className="px-4 py-2 text-right font-semibold">
                                                        {Number(
                                                            item.totalBalance || 0
                                                        ).toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                        <tfoot className="bg-gray-300 font-semibold text-black sticky bottom-0">
                                            <tr>
                                                <td className="px-4 py-2"></td>
                                                <td className="px-4 py-2 text-left">
                                                    Grand Total
                                                </td>

                                                <td className="px-4 py-2 text-right">
                                                    {totalFundDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum +
                                                                parseFloat(item.taxAmount || 0),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>

                                                <td className="px-4 py-2 text-right">
                                                    {totalFundDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum +
                                                                parseFloat(
                                                                    item.nonTaxAmount || 0
                                                                ),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>

                                                <td className="px-4 py-2 text-right">
                                                    {totalFundDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum +
                                                                parseFloat(
                                                                    item.otherAmount || 0
                                                                ),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>

                                                <td className="px-4 py-2 text-right">
                                                    {totalFundDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum +
                                                                parseFloat(
                                                                    item.totalBalance || 0
                                                                ),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TaxNonTaxAmount;